import React from 'react';
import { Link } from 'react-router';

export default class SettingsTabSidebar extends React.Component {
  render() {
    const { activeTab } = this.props;
    return (
      <div className="settings-sidebar-section">
        <ul>
          <li className={activeTab === 'SettingsGeneral' ? 'active' : 'not'}>
            <Link to="/settings/general">General</Link>
          </li>
          <li className={activeTab === 'SettingsEmail' ? 'active' : 'not'}>
            <Link to="/settings/email">Email</Link>
          </li>
          <li className={activeTab === 'SettingsHelpLinks' ? 'active' : 'not'}>
            <Link to="/settings/help">Help Links</Link>
          </li>
          <li
            className={
              activeTab === 'SettingsUMBookingConfig' ? 'active' : 'not'
            }
          >
            <Link to="/settings/um-booking">UM Booking Settings</Link>
          </li>
          <li
            className={activeTab === 'SettingsPageContent' ? 'active' : 'not'}
          >
            <Link to="/settings/pages">Page Content</Link>
          </li>
          <li
            className={
              activeTab === 'SettingsTermsAndConditions' ? 'active' : 'not'
            }
          >
            <Link to="/settings/terms-and-conditions">
              Terms and Conditions
            </Link>
          </li>
          <li className={activeTab === 'SettingsAMBooking' ? 'active' : 'not'}>
            <Link to="/settings/am-bookings">AM Booking Settings</Link>
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sidebars/SettingsTabSidebar.js